import React, { useState,useEffect } from 'react'
import { Modal,Box,Typography,List, ListItem, ListItemIcon, ListItemText, Checkbox,Button} from '@mui/material'
import {useSelector,useDispatch } from "react-redux";
import {setAssigned} from "../Redux/Approver";
import { useMsal } from "@azure/msal-react";
import axios from 'axios';
import { baseURL } from '../Constant';

const ChooseDesigner = ({ openAssignDesignerModal, setOpenAssignDesignerModal,
    assignedDesigners, setAssignedDesigners,loading, setLoading,commId,fileStatus }) => {
    const dispatch= useDispatch();
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const [loggedInUser, setLoggedInUser] = useState(null);

       useEffect(() => {
         if (activeAccount) {
          setLoggedInUser(activeAccount.idTokenClaims.enterpriseID);
         }
        }, [activeAccount]);


    const addAssignedDesigners = async () => {
        setLoading(true);
        try {
            const data= {
                assignedBy:loggedInUser,
                assignedDesigners,//array
                mailerId:commId,
            }
            
            const response = await axios.post(`${baseURL}/designersAssigned/communications`, data,
                {
                    headers:{
                         Authorization: localStorage.getItem('token'),
                        "Content-Type": "application/json",
                    }
                }
            );
            dispatch(setAssigned({
                uniqueID:commId,
                fileStatus:"In-progress",
                assignedBy:loggedInUser,
                assignedTo: assignedDesigners
            }));
        } catch (err) {
            console.log(err);
            alert("Unable to assign designers! Please try again later");
        } finally {
            setLoading(false);
        }
    }


    const userData = useSelector((state) => state.userRoles.UserMaintanenceData);
    const designerList= userData?.filter((user)=>user.Designer==='yes'); //list of all designers from user-maintenance

    const handleToggle = (designerId) => () => {
    const currentIndex = assignedDesigners.findIndex(designer => designer.eid === designerId);
    const newChecked = [...assignedDesigners];

    if (currentIndex === -1) {
      newChecked.push({eid:designerId, submittedppt:null});
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setAssignedDesigners(newChecked);
  };

  const handleSave= async()=>{
    await addAssignedDesigners();
    setAssignedDesigners([]);
    setOpenAssignDesignerModal(false);
  }

  const handleCancel=()=>{
    setAssignedDesigners([]);
    setOpenAssignDesignerModal(false);
  }

  return (
      <Modal
       open={openAssignDesignerModal}
       onClose={()=>setOpenAssignDesignerModal(false)}
      >
          <Box sx={{
              position: 'absolute',
              top: '20%',
              left: '50%',
              transform: 'translate(-50%, -20%)',
              width: "40vw",
              maxHeight:"70vh",
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
          }}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                  Choose designer
              </Typography>
              {loading?"loading...":
                <> 
              <List sx={{maxHeight:"49vh", overflowY:"auto"}}>
                  {designerList.map((designer, index) => (
                      <ListItem
                          key={index}
                          disablePadding
                          onClick={handleToggle(designer.Enterprise_ID)}
                          sx={{ cursor: 'pointer' }}
                      >
                          <ListItemIcon>
                              <Checkbox
                                  edge="start"
                                  checked={assignedDesigners.some(d => d.eid === designer.Enterprise_ID)}
                                  tabIndex={-1}
                                  disableRipple
                              />
                          </ListItemIcon>
                          <ListItemText primary={designer.Enterprise_ID} />
                      </ListItem>
                  ))}
              </List>
              <Box sx={{padding:"8px",display:"flex", justifyContent:"flex-end", gap:"8px"}}>
                <Button sx={{textTransform:"none"}} variant='contained' onClick={handleSave}>Save</Button>
                <Button sx={{textTransform:"none"}} onClick={handleCancel}>Cancel</Button>
              </Box>
              </>}
          </Box>
      </Modal>
  )
}

export default ChooseDesigner